"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePositionRequest = void 0;
var MorePositionRequest = /** @class */ (function () {
    function MorePositionRequest() {
    }
    return MorePositionRequest;
}());
exports.MorePositionRequest = MorePositionRequest;
;
//# sourceMappingURL=morePosition.request.js.map